import React from "react";
import { observer } from "mobx-react-lite";
import { useStores } from "../../hooks/use-stores";
import LibraryPack from "../LibraryPack";
import RascalPodcast from "./RascalPodcast";

export const RASCAL_PODCAST_PACK_IDS = { en: 18386, fr: 18489, es: 18488 };

function RascalPodcastGated() {
  const { authStore } = useStores();
  const hasAccess = !!authStore?.subscriptions?.hasRascalPodcast;

  if (hasAccess) {
    return <LibraryPack packIDs={RASCAL_PODCAST_PACK_IDS} />;
  }
  return <RascalPodcast />;
}

export default observer(RascalPodcastGated);
